import _ from 'lodash'
import {
  SAVE_CUSTOM_FILTERS,
  CUSTOM_FILTERS_REQ,
  UPDATE_CUSTOM_FILTERS,
  DELETE_CUSTOM_FILTERS
} from './custom-filters.type'

import ApiRest from '@/api/api-rest'

const state = {
  customFilter: []
}

const getters = {
  customFilter: state => state.customFilter
}

const mutations = {
  [CUSTOM_FILTERS_REQ]: (state, data) => {
    state.customFilter = data
  }
}

const actions = {
  [SAVE_CUSTOM_FILTERS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('filters', {
          userId: payload.userId,
          tblId: payload.tblId,
          filterName: payload.filterName,
          filterQueries: payload.filterQueries
        })
        .then(resp => {
          resolve(resp.data)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [CUSTOM_FILTERS_REQ](context, { uid, tid } = {}) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('filters')
        .then(({ data }) => {
          let customFilters = data.filter(filt => {
            return filt.tbl_id === tid && filt.user_id === uid
          })
          context.commit(CUSTOM_FILTERS_REQ, customFilters)
          resolve(data)
        })
    })
  },
  [UPDATE_CUSTOM_FILTERS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .put('filters', {
          id: payload.id,
          filterName: payload.name
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [DELETE_CUSTOM_FILTERS](context, id) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .delete(`filters/${id}`)
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/custom-filters/custom-filters.module.js